import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorResponse } from 'src/app/models/error.model';
import { Cobertura } from 'src/app/models/cobertura.model';
import { Zona } from 'src/app/models/zona.model';
import { CoberturasService } from 'src/app/services/coberturas.service';
import { ZonasService } from 'src/app/services/zonas.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-edit-cobertura',
    templateUrl: './edit-cobertura.component.html',
    styleUrls: ['./edit-cobertura.component.scss']
})
export class EditCoberturaComponent implements OnInit {

    cobertura?: Cobertura;
    zonas: Zona[] = [];

    form = new UntypedFormGroup({
        nombre: new UntypedFormControl('', [Validators.required]),
        tipoProducto: new UntypedFormControl('VIVIENDA', [Validators.required]),
        porcentaje: new UntypedFormControl(null, [Validators.required]),
        topeMinimo: new UntypedFormControl(null, [Validators.required]),
        topeMaximo: new UntypedFormControl(null, [Validators.required]),
        idZona: new UntypedFormControl(null),
        activo: new UntypedFormControl(true, [Validators.required])
    });

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private coberturasService: CoberturasService,
        private zonasService: ZonasService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.loadZonas();
        this.route.params.subscribe(params => {
            if (params?.id) {
                this.coberturasService.getCoberturaById(params.id).subscribe({
                    next: cobertura => {
                        this.cobertura = cobertura;
                        this.form.setValue({
                            nombre: cobertura.nombre,
                            tipoProducto: cobertura.tipoProducto,
                            porcentaje: cobertura.porcentaje,
                            topeMinimo: cobertura.topeMinimo,
                            topeMaximo: cobertura.topeMaximo,
                            idZona: cobertura.idZona ?? null,
                            activo: cobertura.activo
                        });
                    },
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener la cobertura', error.error?.descripcion)
                });
            }
        });
    }

    loadZonas() {
        this.zonasService.getZonas(0, 200, [], { 'ocultar-inactivos': 'false' }).subscribe({
            next: response => { this.zonas = response.body ?? []; }
        });
    }

    get zonaLabel(): string {
        const id = this.cobertura?.idZona;
        if (!id) return 'Default';
        return this.zonas.find(z => z.id === id)?.nombre ?? `Zona ${id}`;
    }

    save() {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        const v = this.form.value;
        const payload: Cobertura = {
            nombre: v.nombre,
            tipoProducto: v.tipoProducto,
            porcentaje: v.porcentaje,
            topeMinimo: v.topeMinimo,
            topeMaximo: v.topeMaximo,
            idZona: v.idZona || null,
            activo: v.activo
        };
        if (this.cobertura) {
            this.coberturasService.updateCobertura({ ...payload, id: this.cobertura.id }).subscribe({
                next: () => {
                    this.utilsService.alert('Cobertura actualizada', `"${payload.nombre}" fue actualizada correctamente.`);
                    this.navigateBack();
                },
                error: (error: ErrorResponse) => this.utilsService.alert('Error al actualizar', error.error?.descripcion)
            });
        } else {
            this.coberturasService.createCobertura(payload).subscribe({
                next: () => {
                    this.utilsService.alert('Cobertura creada', `"${payload.nombre}" fue creada correctamente.`);
                    this.navigateBack();
                },
                error: (error: ErrorResponse) => this.utilsService.alert('Error al crear', error.error?.descripcion)
            });
        }
    }

    cancel() {
        this.navigateBack();
    }

    private navigateBack() {
        this.router.navigate(['configuracion', 'calculadora', 'coberturas']);
    }
}
